import { SAVE_SELECTED_PRODUCT } from "Constants/redux";

export default  (state ={},action)=>{
  switch(action.type){
    case SAVE_SELECTED_PRODUCT :
      return action.payload
    default :
      return state
  }
}